"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rollPotionVariants = exports.getRandomPotionVariant = exports.findPotionVariantComboByType = exports.potionVariantCombos = void 0;
var ROT = __importStar(require("rot-js"));
var assert_sidecar_1 = require("../../../lib/assert-sidecar");
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueItemsData_1 = require("./rogueItemsData");
var rogueItemsData_sidecar_1 = require("./rogueItemsData-sidecar");
var _potionVariants = [
    {
        group: rogueItemsData_1.ERogueItemGroup.potion,
        name: 'orange',
        color: rogueDef_sidecar_1.rogueDef.colors.orange,
    },
    {
        group: rogueItemsData_1.ERogueItemGroup.potion,
        name: 'red',
        color: rogueDef_sidecar_1.rogueDef.colors.red,
    },
    {
        group: rogueItemsData_1.ERogueItemGroup.potion,
        name: 'yellow',
        color: rogueDef_sidecar_1.rogueDef.colors.yellow,
    },
    {
        group: rogueItemsData_1.ERogueItemGroup.potion,
        name: 'white',
        color: rogueDef_sidecar_1.rogueDef.colors.light,
    },
    {
        group: rogueItemsData_1.ERogueItemGroup.potion,
        name: 'blue',
        color: rogueDef_sidecar_1.rogueDef.colors.darkBlue,
    },
    {
        group: rogueItemsData_1.ERogueItemGroup.potion,
        name: 'green',
        color: rogueDef_sidecar_1.rogueDef.colors.green,
    },
    {
        group: rogueItemsData_1.ERogueItemGroup.potion,
        name: 'brown',
        color: rogueDef_sidecar_1.rogueDef.colors.brown,
    },
];
exports.potionVariantCombos = [];
var findPotionVariantComboByType = function (type) {
    var combo = exports.potionVariantCombos.find(function (c) { return c.data.type === type; }) || null;
    assert_sidecar_1.assert.notNil(combo, "findPotionVariantComboByType: combo not found for type ".concat(type));
    return combo;
};
exports.findPotionVariantComboByType = findPotionVariantComboByType;
var getRandomPotionVariant = function () {
    var items = {};
    exports.potionVariantCombos.forEach(function (c) {
        items[c.data.type] = c.data.spawnChance;
    });
    var type = ROT.RNG.getWeightedValue(items) || '?';
    var combo = (0, exports.findPotionVariantComboByType)(type);
    return combo;
};
exports.getRandomPotionVariant = getRandomPotionVariant;
var rollPotionVariants = function () {
    var variantsCopy = _potionVariants.map(function (c) { return c; });
    variantsCopy = rando_sidecar_1.rando.shuffle(variantsCopy);
    rando_sidecar_1.rando.clearArray(exports.potionVariantCombos);
    rogueItemsData_sidecar_1.rogueItemsData.dataListPotions.forEach(function (c) {
        var v = rando_sidecar_1.rando.sampleAndRemove(variantsCopy);
        exports.potionVariantCombos.push({
            variant: v,
            data: c,
            isIdentified: false,
        });
    });
};
exports.rollPotionVariants = rollPotionVariants;
